import { Component } from '@angular/core';
import { Router, ActivationEnd } from '@angular/router';

import { environment } from '@env/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'Partbnb';
  private currentUrl;

  constructor(private router: Router) {
    router.events.subscribe(event => {
      if (
        event instanceof ActivationEnd &&
        this.currentUrl !== router.url.toString() &&
        environment.activateGA
      ) {
        this.currentUrl = router.url.toString();
        (<any>window).ga('set', 'page', this.currentUrl);
        (<any>window).ga('set', 'title', event.snapshot.data.pageTitle);
        (<any>window).ga('send', 'pageview');
      }
    });
  }
}
